import React from "react";
import PaginationPage from "./PaginationPage";
import {calculateInRangePage, calculateTotalPages, calculatePageChange} from "../helpers/calculations";

const Pagination = (props) => {
    const handlePageClick = (pageName) => {
        let pageNumber = calculatePageChange(props.totalItemsCount, props.itemsPerPage, props.currentPage, pageName);
        props.onPageChange(pageNumber);
    }
    
    let totalPages = calculateTotalPages(props.totalItemsCount, props.itemsPerPage);
    let currentPage = calculateInRangePage(props.totalItemsCount, props.itemsPerPage, props.currentPage);
    
    if (totalPages === 1) return null;

    const paginationPages = [];
    for (let i = 0; i < totalPages; i++) {
        let pageNum = i+1;
        paginationPages.push(<PaginationPage key={pageNum} pageName={pageNum.toString()} isActive={currentPage === pageNum} onPageClick={handlePageClick} />);
    }
    
    return (
        <nav aria-label="Pagination">
            <ul className="pagination">
                {currentPage > 1 &&
                    <PaginationPage key="paginationPrevious" pageName="Previous" isActive={false} onPageClick={handlePageClick} />
                }
                {paginationPages}
                {currentPage < totalPages &&
                    <PaginationPage key="paginationNext" pageName="Next" isActive={false}  onPageClick={handlePageClick} />
                }
            </ul>
        </nav>
    )
}

export default Pagination;